import { z } from 'zod';

/**
 * Публичный Код личности — читаемая формула, без внутренних методик.
 * Считается из socionicsType / psychotype(+counts) / archetype; в JSON гостя
 * внутренних кодов быть не должно.
 */
export const PublicPersonalityCodeDto = z.object({
  display: z.string(),
  core: z.object({
    name: z.string(),
    description: z.string(),
  }),
  rhythm: z.object({
    primary: z.string(),
    secondary: z.string(),
    tertiary: z.string(),
    full: z.array(z.string()).length(7),
  }),
  image: z.object({
    name: z.string(),
    description: z.string(),
  }),
});
export type PublicPersonalityCode = z.infer<typeof PublicPersonalityCodeDto>;
